import {AsyncPipe} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {Store} from '@ngxs/store';
import {RtTitlesState} from 'rt-titles';

@Component({
    selector: 'rt-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        IonicModule,
        AsyncPipe,
    ]
})
export class HeaderComponent {
  title$ = this.store.select(RtTitlesState.currentTitle);

  constructor(private store: Store) {}

  @Input() type = 'menu';
  @Input() redirect: string;
}
